// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-search-results-text__indicator {
  position: relative;
  text-align: center;
  width: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/search/ui/FilterSearchResultsText.less"],"names":[],"mappings":"AAEE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;AADJ","sourcesContent":[".filter-search-results-text {\n\n  &__indicator {\n    position: relative;\n    text-align: center;\n    width: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
